import PasswordResetSuccess from './password-reset-success';

export default PasswordResetSuccess;
